<template>
	<div class="document-menu">
		<div class="document-menu-body">
			<link-tree ref="tree" :levelSpace="20" :data="menus" labelKey="title" childrenKey="children" class="document-menu-tree" @node-click="handleNodeClick" :nodeClass="nodeClass">
				<div slot-scope="{data,index}" class="document-menu-item">
					<link-tooltip-text :content="data.title">
						<span class="document-menu-item-index" v-if="showMenuIndex">{{!!data.category?'':index}}. </span>
						<span>{{data.title}}&nbsp;<span v-if="!data.category && !data.children" class="menu-item-author">{{data.author ? `[${data.author}]` : '[未知作者]'}}</span></span>
					</link-tooltip-text>
				</div>
			</link-tree>
		</div>
	</div>
</template>

<script>
	export default {
		name: "document-menu",
		props: {
			menus: {},
			curMenu: {},
			showMenuIndex: {type: Boolean},
		},
		methods: {
			handleNodeClick({node: {data}}) {
				!!data.id && (!this.curMenu || data.id !== this.curMenu.id) && this.$emit('click', data)
			},
			nodeClass(data) {
				const ret = []
				if (!!data.id) {
					ret.push('document-menu-has-id')
				}
				if (!!this.curMenu && data.id === this.curMenu.id) {
					ret.push('document-menu-current')
				}
				if (!!data.category) {
					ret.push('document-menu-category')
				}
				return ret
			},
			locate(menu) {
				this.$refs.tree.scrollTo(treeNode => treeNode.node.data.id === menu.id && treeNode.node.data.title === menu.title)
			},
		}
	}
</script>

<style lang="scss">
	@include themeify {
		.document-menu {

			.document-menu-body {
				height: 100%;
			}

			.document-menu-tree {
				padding-bottom: 300px;
			}

			.link-tree-node-content-wrapper {
				padding: 0 18px 0 36px;
			}

			.document-menu-item {
				height: 40px;
				line-height: 40px;
				font-size: 14px;
				color: #314659;

				.document-menu-item-index {
					color: #999;
					font-size: 14px;
					vertical-align: bottom;
					font-style: italic;
				}
				.menu-item-author{
					font-size:12px;
					color: #999;
				}
			}

			.document-menu-category {
				color: #aaa;
				width: 100%;
				text-align: center;
				background-color: #f8f8f8;

				.document-menu-item {
					height: 28px;
					line-height: 28px;
					font-size: 14px;
					color: pl-var(color-primary);
				}

				.link-tree-node-content {
					margin-left: -12px;
				}
			}

			.document-menu-current {
				background-color: pl-var(color-primary-light);
				border-right: 4px solid pl-var(color-primary);
			}
		}
	}
</style>
